import { Injectable } from '@angular/core';
import { Network } from "@capacitor/network";

@Injectable({
  providedIn: 'root'
})

export class NetworkService {

  constructor() { }

  async deviceConnected(): Promise<boolean> {
    let status = await Network.getStatus();

    if (status) {
      return Promise.resolve(status['connected']);
    } else {
      return Promise.reject(false);
    }
  }
}
